"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedRecordFieldLogic = void 0;
var linked_record_fieldtype_1 = require("./linked-record.fieldtype");
Object.defineProperty(exports, "LinkedRecordFieldLogic", { enumerable: true, get: function () { return linked_record_fieldtype_1.LinkedRecordFieldLogic; } });
